export * from "./skeleton.component";
